import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';

@Component({
  selector: 'ins-creator-action-panel',
  templateUrl: './action-panel.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block rounded-lg border border-border bg-surface shadow-sm' },
})
export class CreatorActionPanel {
  title = input.required<string>();
  subtitle = input<string | undefined>(undefined);
  expanded = model(false);
  warning = input(false);

  toggleExpanded(): void {
    this.expanded.update((value) => !value);
  }
}
